import {AfterViewInit, Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {DataTableDirectives} from "angular2-datatable/datatable";
import {FORM_DIRECTIVES, FORM_PROVIDERS, FormControl, FormGroup, REACTIVE_FORM_DIRECTIVES} from "@angular/forms";
import {AlertComponent, BS_VIEW_PROVIDERS, MODAL_DIRECTIVES} from "ng2-bootstrap/ng2-bootstrap";
import {PaginatePipe, PaginationControlsCmp, PaginationService} from "ng2-pagination";
import {Vehicle} from "../domain/vehicle";
import {Page} from "../domain/page";
import {LoginService} from "../service/login.service";
import {User} from "../domain/user";
import {FILE_UPLOAD_DIRECTIVES} from "ng2-file-upload/ng2-file-upload";
import {Bank} from "../domain/bank";
import {BankService} from "../service/bank.service";
import {ProcedureType} from "../domain/procedureType";
import {Procedure} from "../domain/procedure";
import {ProcedureService} from "../service/procedure.service";
import {AgendaService} from "../service/agenda.service";
import {DATE_VALID_CHARACTERS, DATE_VALIDATOR, DEFAULT_ERROR_MESSAGES, IsExpirated} from "../validators/validators";

@Component({
    selector: 'agenda-panel',
    template: require('./agenda.panel.component.html'),
    styles: [require('./agenda.panel.component.css')],
    directives: [
        DataTableDirectives,
        FORM_DIRECTIVES,
        REACTIVE_FORM_DIRECTIVES,
        AlertComponent,
        MODAL_DIRECTIVES,
        PaginationControlsCmp,
        FILE_UPLOAD_DIRECTIVES
    ],
    providers: [
        FORM_PROVIDERS,
        PaginationService
    ],
    viewProviders: [BS_VIEW_PROVIDERS],
    pipes: [
        PaginatePipe,
        IsExpirated
    ]
})
export class AgendaPanelComponent implements OnInit, AfterViewInit {

    public errorMessages: any;

    private data: Procedure[];

    private banks: Bank[];

    private procedureTypes: ProcedureType[];

    public bankTodos: Bank;

    public typeTodos: ProcedureType;

    private filter: Vehicle;

    public expirationDateSince: string;
    public expirationDateUntil: string;

    public error: any;
    public reportMessage: string;

    private currentPage: Page;

    public form: FormGroup;

    public itemsPerPage: number;
    public loading: boolean;
    public page: number;
    public total: number;

    private userLogged: User;

    public canViewAgenda: boolean;

    public canEditAgenda: boolean;

    public showFilters: boolean;

    public withDocuments: boolean;

    constructor(private router: Router,
                private procedureService: ProcedureService,
                private agendaService: AgendaService,
                private bankService: BankService,
                private loginService: LoginService) {
        this.init();

        bankService.getBanks().subscribe(
            this.setBanks.bind(this),
            () => {
                this.bindError('Ocurrió un error al cargar los bancos.');
            });

        this.procedureService.getProcedureTypes().subscribe(
            this.setProcedureTypes.bind(this),
            () => {
                this.bindError('Ocurrió un error al cargar los tipos de trámites.');
            });

        /*Descomentar si se quiere filtrar en cuanto el formulario cambie*/
        /*this.form.valueChanges
         .debounceTime(400)
         .subscribe(this.find.bind(this));*/
    }

    private init(): void {
        this.data = [];

        this.errorMessages = DEFAULT_ERROR_MESSAGES;

        this.banks = [];

        this.procedureTypes = [];

        this.itemsPerPage = 10;
        this.loading = false;
        this.page = 1;
        this.total = 0;

        this.bankTodos = new Bank();
        this.bankTodos.id = '';
        this.bankTodos.name = 'TODOS';

        this.typeTodos = new ProcedureType();
        this.typeTodos.id = '';
        this.typeTodos.name = 'ALL';
        this.typeTodos.description = 'TODOS';

        this.canViewAgenda = false;

        this.canEditAgenda = false;

        this.showFilters = false;

        this.filter = new Vehicle();
        this.form = new FormGroup({
            patent: new FormControl(),
            bank: new FormControl(),
            contractNumber: new FormControl(),
            cuit: new FormControl(),
            procedureType: new FormControl(),

            expirationDateSince: new FormControl(this.expirationDateSince, [DATE_VALID_CHARACTERS, DATE_VALIDATOR, this.validateExpirationDateSinceRequired.bind(this)]),
            expirationDateUntil: new FormControl(this.expirationDateUntil, [DATE_VALID_CHARACTERS, DATE_VALIDATOR, this.validateExpirationDateUntilRequired.bind(this)]),

            itemsPerPage: new FormControl(),

            withDocuments: new FormControl()
        });

        if (!this.filter.contract.bank.id) {
            this.filter.contract.bank = this.bankTodos;
        }

        this.filter.procedures = [];
        this.filter.procedures[0] = new Procedure(null);
        this.filter.procedures[0].type = this.typeTodos;

        this.withDocuments = false;
    }

    public find(): void {
        this.getData(1);
    }

    public filterEmpty(): boolean {
        return !(this.filter.patent || this.filter.contract.contractNumber || this.filter.contract.cuit
            || (this.filter.contract.bank && this.filter.contract.bank.id != '')
            || (this.filter.procedures.length > 0 && this.filter.procedures[0].type.id != '')
            || (this.expirationDateSince && this.expirationDateUntil));
    }

    private setBanks(banks: Bank[]): void {
        this.banks = banks;
        if (banks.length == 1) {
            this.filter.contract.bank = banks[0];
        }
    }

    private setProcedureTypes(procedureTypes: ProcedureType[]): void {
        this.procedureTypes = procedureTypes;
        if (procedureTypes.length == 1) {
            this.filter.procedures = [];
            this.filter.procedures[0] = new Procedure(null);
            this.filter.procedures[0].type = procedureTypes[0];
        }
    }

    private getData(page: number): void {
        this.error = null;
        this.reportMessage = null;
        if (!this.filterEmpty()) {
            this.loading = true;

            if (this.expirationDateSince && this.expirationDateUntil) {
                if (this.filter.procedures.length == 0) {
                    this.filter.procedures = [];
                    this.filter.procedures[0] = new Procedure(null);
                }
                this.filter.procedures[0].expirationDateSince = this.expirationDateSince;
                this.filter.procedures[0].expirationDateUntil = this.expirationDateUntil;
            }

            this.agendaService.findProcedure(this.filter, page, this.itemsPerPage).subscribe(
                (data) => {
                    this.refreshData(data);
                    this.page = page;
                },
                () => {
                    this.bindError('Ocurrió un error al buscar los trámites.');
                });
        }
    }

    private refreshData(page: Page): void {
        this.data = page.content;
        this.currentPage = page;
        this.total = page.totalElements;
        this.loading = false;
    }

    public downloadFilterProcedures(): void {
        this.error = null;
        if (!this.filterEmpty()) {
            this.loading = true;

            this.reportMessage = 'Creando reporte...';
            if (this.withDocuments) {
                if (this.total < 3000) {
                    /*TODO: muchos documentos puede que rompa por timeout*/
                    this.reportMessage = 'Creando reporte...';
                }
            }

            /*
             * Se exportan todos los trámites de vehículos que cumplan con el filtro.
             * Sólo los trámites de vehículos de la página actual se descargan.
             */
            window.location.href = window.location.origin +
                AgendaService.getURLFilterProcedures(this.filter, this.page, this.itemsPerPage, this.withDocuments);

            this.loading = false;
        }
    }

    public close(saved: Vehicle): void {
        if (saved) {
            this.find();
        }
    }

    public getPage(page: number): void {
        this.getData(page);
    }

    public ngOnInit() {
        this.userLogged = this.loginService.getUserLogged();
        this.canViewAgenda = this.userLogged.isActionAllowed('AGENDA', 'VIEW', 'AGENDA');
        this.canEditAgenda = this.userLogged.isActionAllowed('AGENDA', 'EDIT', 'AGENDA');

        if (this.userLogged.rol.client) {
            if (this.userLogged.cuit) {
                this.filter.contract.cuit = this.userLogged.username;
            } else {
                this.filter.patent = this.userLogged.username;
            }
            this.filter.contract.bank.id = this.userLogged.bank.id;
            this.showFilters = false;
        } else {
            this.showFilters = true;
        }
        this.getPage(1);
    }

    public ngAfterViewInit() {
    }

    private bindError(messageError: string): void {
        this.loading = false;
        if (this.error == null) {
            this.error = messageError;
        } else {
            this.error = this.error.toString() + ' ' + messageError;
        }
    }

    public resolveItem(item: Procedure): void {
        this.error = null;
        this.reportMessage = null;
        this.loading = true;

        this.agendaService.resolveProcedure(item.id).subscribe(
            (procedure) => {
                if (procedure.id != '' && procedure.id != null) {
                    this.reportMessage = 'Trámite ' + item.type.description + ' de vehículo '
                        + item.vehicle.patent + ' resuelto correctamente.';
                    this.removeItemFromView(item);
                } else {
                    this.bindError('Ocurrió un error al resolver el trámite.');
                }
            },
            () => {
                this.bindError('Ocurrió un error al resolver el trámite.');
            });
        this.loading = false;
    }

    private removeItemFromView(procedure: Procedure): void {
        let index = this.data.indexOf(procedure);
        if (index > -1) {
            this.data.splice(index, 1);
        }
    }

    private validateExpirationDateSinceRequired(group: FormControl): any {
        if (!this.expirationDateSince && this.expirationDateUntil) {
            this.form.controls['expirationDateUntil'].updateValueAndValidity();
            return {
                required: true
            };
        }
        return null;
    }

    private validateExpirationDateUntilRequired(group: FormControl): any {
        if (this.expirationDateSince && !this.expirationDateUntil) {
            this.form.controls['expirationDateSince'].updateValueAndValidity();
            return {
                required: true
            };
        }
        return null;
    }

    public triggerExpirationDateValidators(): void {
        this.form.controls['expirationDateSince'].updateValueAndValidity();
        this.form.controls['expirationDateUntil'].updateValueAndValidity();
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/agenda/agenda.panel.component.ts
 **/